/**
 * コンソールログの出力クラス
 */

class DebugConsole
{
  /**
   * コンストラクタ
   * @constructor
   */
  constructor()
  {
    // サーバーの環境変数を取得
    this.environment = APP_ENV;

    // ローカルの場合はコンソールに出力する
    if (APP_ENV == 'local') {
      for (const m in console) {
        if (typeof console[m] == 'function') {
          this[m] = console[m].bind(window.console);
        }
      }
    }
    // ローカル以外の場合はコンソールに出力しない
    else {
      for (const m in console) {
        if (typeof console[m] == 'function') {
          this[m] = function(){}
        }
      }
    }
  }
}

export default DebugConsole;
